//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'couponDetail',
    data() {
        return {
            coupon: {
                name: ''
            }, loading: false
        };
    },
    methods: {
        getById() {
            this.loading = true;
            this.$store.dispatch({
                type: 'coupon/GetCouponById',
                id: this.id
            }).then(() => {
                this.coupon = this.$store.state.coupon.cityInfo;
            }).finally(() => {
                this.loading = false;
            });
        },
        editCoupon(c) {
            // this.coupon = {};
            // this.coupon = JSON.parse(JSON.stringify(c));
            // this.showEidtCouponModel = true;
            this.$router.push({
                name: 'couponEdit',
                params: {
                    id: c.id
                }
            });
        },
        onSubmit(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认提交审核吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.saving = true;
                    await this.$store.dispatch({
                        type: 'coupon/submit',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '提交成功'
                        });
                        vm.getById();
                    }).finally(() => {
                        vm.saving = false;
                    });

                }
            });
        },
        onApprove(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认发布吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.saving = true;
                    await this.$store.dispatch({
                        type: 'coupon/approve',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '发布成功'
                        });
                        vm.getById();
                    }).finally(() => {
                        vm.saving = false;
                    });

                }
            });
        },
        onUnApprove(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认取消吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    vm.saving = true;
                    await this.$store.dispatch({
                        type: 'coupon/unApprove',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '取消成功'
                        });
                        vm.getById();
                    }).finally(() => {
                        vm.saving = false;
                    });

                }
            });
        },
        delCoupon(row) {
            const vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除' + row.name + '吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'coupon/delCoupon',
                        id: row.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.$router.push({ name: 'couponsList' });
                    }).finally(() => {

                    });

                }
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getById();
        }
    }
};
